import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createSlots as _createSlots, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["id"];
import { computed, ref, shallowRef } from "vue";
import AppShowPersonEventStaffFunctionStatus from "./AppShowPersonEventStaffFunctionStatus.vue";
import { PersonEventStaffFunctionStatus } from "@/types/eventStaffFunctions/personEventStaffFunction";
import gql from "fraql";
import allowedMutations from "@/utils/allowedMutation";
import { computePosition } from "@floating-ui/dom";
import { injectSnackbarError } from "@/composables/injections";
import { apolloClient } from "@/plugins/apollo";
import AppShowActivityLogs from "@AppShows/AppShowActivityLogs.vue";
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: "AppShowPersonEventStaffFunctionStatusEdit",
        fragments: {
            personEventStaffFunctionFields: gql `
      fragment _ on PersonEventStaffFunction {
        ${AppShowPersonEventStaffFunctionStatus.fragments.personEventStaffFunctionFields}
        allowedMutations
      }
    `
        }
    },
    __name: 'AppShowPersonEventStaffFunctionStatusEdit',
    props: {
        personEventStaffFunction: {},
        teleportEditTarget: { default: "body" }
    },
    setup(__props) {
        const props = __props;
        const menuVisible = ref(false);
        const loading = ref(false);
        const root = shallowRef();
        const statusChip = shallowRef();
        const menuTarget = shallowRef();
        const { snackbarServerError } = injectSnackbarError();
        // in order: CANDIDATE SELECTED RESERVED WITHDRAWN NOT_SELECTED
        const statusSelections = computed(() => [
            {
                mutation: "personEventStaffFunctionUpdateStatusToCandidate",
                mock: {
                    status: PersonEventStaffFunctionStatus.CANDIDATE
                }
            },
            {
                mutation: "personEventStaffFunctionMarkSelected",
                mock: {
                    status: PersonEventStaffFunctionStatus.SELECTED
                }
            },
            {
                mutation: "personEventStaffFunctionReserve",
                mock: {
                    status: PersonEventStaffFunctionStatus.RESERVED
                }
            },
            {
                mutation: "personEventStaffFunctionWithdraw",
                mock: {
                    status: PersonEventStaffFunctionStatus.WITHDRAWN
                }
            },
            {
                mutation: "personEventStaffFunctionMarkNotSelected",
                mock: {
                    status: PersonEventStaffFunctionStatus.NOT_SELECTED
                }
            }
        ].filter(x => allowedMutations(props.personEventStaffFunction.allowedMutations, x.mutation)));
        const editable = computed(() => allowedMutations(props.personEventStaffFunction.allowedMutations, [
            "personEventStaffFunctionWithdraw",
            "personEventStaffFunctionMarkSelected",
            "personEventStaffFunctionMarkNotSelected",
            "personEventStaffFunctionReserve",
            "personEventStaffFunctionUpdateStatusToCandidate"
        ]));
        function openMenu() {
            if (loading.value)
                return;
            if (menuVisible.value) {
                menuVisible.value = false;
                return;
            }
            if (!editable.value)
                return;
            computePosition(statusChip.value.$el, menuTarget.value, {
                placement: "bottom-start"
            }).then(({ x, y }) => {
                Object.assign(menuTarget.value.style, {
                    left: `${x - 14}px`,
                    top: `${y - 22 - 13}px` // 22px from chip-s height, 12px from padding-top
                });
                menuVisible.value = true;
            });
        }
        async function changeStatus(mutation) {
            if (loading.value)
                return;
            menuVisible.value = false;
            loading.value = true;
            try {
                await apolloClient.mutate({
                    mutation: gql `
        mutation ${mutation} ($id: ID!) {
          ${mutation}(input: { id: $id }) {
            personEventStaffFunction {
              id
              status
              activityLogs {
                ${AppShowActivityLogs.fragments.activityLogFields}
              }
              allowedMutations
            }
          }
        }
      `,
                    variables: {
                        id: props.personEventStaffFunction.id
                    }
                });
            }
            catch (err) {
                snackbarServerError(err, { level: "error" });
            }
            finally {
                loading.value = false;
            }
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn_icon = _resolveComponent("v-btn-icon");
            const _directive_click_outside = _resolveDirective("click-outside");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "root",
                ref: root,
                class: _normalizeClass(["status-chip-wrapper", { 'status-chip-menu-open': menuVisible.value }])
            }, [
                _createVNode(AppShowPersonEventStaffFunctionStatus, _mergeProps({
                    ref_key: "statusChip",
                    ref: statusChip,
                    "person-event-staff-function": _ctx.personEventStaffFunction,
                    class: {
                        'status-chip-editable': editable.value,
                        'd-inline-flex': true
                    },
                    "aria-controls": '#staff-status-menu-' + _ctx.personEventStaffFunction.id,
                    "aria-expanded": menuVisible.value
                }, {
                    onClick: editable.value ? () => openMenu() : undefined
                }), _createSlots({ _: 2 }, [
                    (editable.value)
                        ? {
                            name: "append",
                            fn: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                    size: "16px",
                                    loading: loading.value,
                                    class: "ma-0 ml-auto text-end",
                                    slim: "",
                                    color: "transparent"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(menuVisible.value ? "$iconCaretUp" : "$iconCaretDown"), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["loading"])
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1040, ["person-event-staff-function", "class", "aria-controls", "aria-expanded"]),
                (editable.value)
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 0,
                        to: _ctx.teleportEditTarget
                    }, [
                        _withDirectives((_openBlock(), _createElementBlock("div", {
                            id: 'staff-status-menu-' + _ctx.personEventStaffFunction.id,
                            ref_key: "menuTarget",
                            ref: menuTarget,
                            role: "alert",
                            class: "status-menu"
                        }, [
                            _createVNode(AppShowPersonEventStaffFunctionStatus, {
                                "person-event-staff-function": _ctx.personEventStaffFunction,
                                class: "d-inline-flex status-chip-editable",
                                onClick: openMenu
                            }, _createSlots({ _: 2 }, [
                                (editable.value)
                                    ? {
                                        name: "append",
                                        fn: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                                size: "16px",
                                                loading: loading.value,
                                                class: "ma-0 ml-auto text-end",
                                                slim: "",
                                                color: "transparent"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(menuVisible.value ? "$iconCaretUp" : "$iconCaretDown"), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }, 8, ["loading"])
                                        ]),
                                        key: "0"
                                    }
                                    : undefined
                            ]), 1032, ["person-event-staff-function"]),
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "divider mt-2 mb-2" }, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusSelections.value, (status, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: status.mutation
                                }, [
                                    _createVNode(AppShowPersonEventStaffFunctionStatus, {
                                        "person-event-staff-function": status.mock,
                                        style: { "width": "100%", "text-align": "center" },
                                        class: _normalizeClass({ 'mb-2': statusSelections.value.length - 1 != index }),
                                        onClick: () => changeStatus(status.mutation)
                                    }, null, 8, ["person-event-staff-function", "class", "onClick"])
                                ]));
                            }), 128))
                        ], 8, _hoisted_1)), [
                            [_vShow, menuVisible.value],
                            [_directive_click_outside, {
                                    handler: () => (menuVisible.value = false),
                                    include: () => [statusChip.value.$el]
                                }]
                        ])
                    ], 8, ["to"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
